<script lang="ts" setup>
  import { computed } from "vue";
  import Icon from "@/components/Icon.vue";

  const props = withDefaults(defineProps<{
    modelValue?: boolean;
    dark?: boolean;
    skipCloseButton?: boolean;
    compact?: boolean;
  }>(),
  {
    dark: true,
    skipCloseButton: false,
    compact: false,
  });
  const emit = defineEmits<{
    'update:modelValue': [value: boolean];
    'close': [];
  }>();

  const value = computed<boolean>({
    get() {
      return props.modelValue;
    },
    set(value) {
      emit('update:modelValue', value);
      if (!value) {
        emit('close');
      }
    },
  });
</script>

<template>
  <v-dialog
    v-model="value"
    transition="dialog-bottom-transition"
    class="base-modal"
  >
    <template v-slot:default>
      <button
        v-if="!props.skipCloseButton"
        :class="['close', { light: !props.dark }]"
        @click="value = false"
      >
        <Icon icon="close"/>
      </button>

      <!-- Content -->
      <slot></slot>
    </template>
  </v-dialog>
</template>

<style lang="scss" scoped>

  // Default content
  .base-modal {
    :deep(.v-overlay__content) {
      max-width: 90%;
      min-width: 300px;
      width: auto;

      & > .default-bg {
        background-color: #FFFFFF;
        border-radius: 24px;
        padding: 47px 73px;

        & + .close {
          color: rgb(var(--v-theme-neutral-600));
          border: 1px solid rgba(var(--v-theme-neutral-200));

          &:hover {
            background-color: rgba(var(--v-theme-neutral-200), 0.4);
          }
        }
      }
    }
  }

  .close {
    position: absolute;
    top: 30px;
    right: 30px;
    padding: 0;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    color: rgb(var(--v-theme-background));
    border: 1px solid rgba(var(--v-theme-background), 0.35);
    transition: 0.5s ease all;
    z-index: 10;
  }

  .close:hover {
    background-color: rgba(var(--v-theme-background), 0.2);
    border: 1px solid transparent;
  }

  .close.light {
    color: rgb(var(--v-theme-on-background));
    border: 1px solid rgba(var(--v-theme-on-background), 0.35);
  }

  .close.light:hover {
    background-color: rgba(var(--v-theme-on-background), 0.2);
  }

  @media(max-width: breakpoint(md) - 1px) {
    .base-modal {
      width: 100%;
      padding: 0;
      margin: 0;
    }

    .v-dialog {
      justify-content: end;
      align-items: end
    }

    .v-dialog :deep(.v-overlay__content) {
      min-width: 100% !important;
      width: 100% !important;
      max-width: 100% !important;
      margin: 0;
    }

    .close {
      left: 30px;
    }

    // Default content
    .base-modal {
      :deep(.v-overlay__content) {
        & > .default-bg {
          padding: 89px 41px;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
    }
  }
</style>
